import { FunctionComponent } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

import {
	faArrowUpRight,
	faMagnifyingGlass,
	faUsers,
	faWandMagicSparkles,
} from "@fortawesome/pro-regular-svg-icons";

import { Icon } from "@/components/Icon/Icon";
import { ROUTE_CONFIG } from "@/routes/config";

export const SmartListPointerCard: FunctionComponent = () => {
	const { t } = useTranslation();
	const navigate = useNavigate();
	const ts = (key: string) => t(`list.reengage.${key}`);

	return (
		<div className="mt-4 rounded-xl border border-status-info-light bg-status-info-light/30 p-4.5">
			<div className="flex items-center gap-2 mb-2">
				<div className="w-7 h-7 rounded-md bg-white text-brand-light flex items-center justify-center border border-status-info-light">
					<Icon className="w-3.5 h-3.5" icon={faWandMagicSparkles} />
				</div>
				<div className="text-[13px] font-semibold text-text">{ts("pointerTitle")}</div>
			</div>
			<div className="text-[12.5px] text-text-meta leading-relaxed mb-3">{ts("pointerBody")}</div>
			<div className="flex gap-2">
				<button
					className="inline-flex items-center gap-1.5 text-xs font-medium text-brand-light bg-white border border-status-info-light rounded-md px-2.5 py-1.5 hover:bg-brand-light hover:text-white"
					type="button"
					onClick={() => navigate(ROUTE_CONFIG.CONTACTS)}
				>
					<Icon className="w-3 h-3" icon={faUsers} />
					{ts("openContacts")}
					<Icon className="w-3 h-3" icon={faArrowUpRight} />
				</button>
				<button
					className="inline-flex items-center gap-1.5 text-xs font-medium text-brand-light bg-white border border-status-info-light rounded-md px-2.5 py-1.5 hover:bg-brand-light hover:text-white"
					type="button"
					onClick={() => navigate(ROUTE_CONFIG.CONTACTS)}
				>
					<Icon className="w-3 h-3" icon={faMagnifyingGlass} />
					{ts("trySemanticSearch")}
				</button>
			</div>
		</div>
	);
};
